import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useTeam, useAuthorArticles } from '../api/fetchExampleData'; // Usa le query hook
import LatestNews from '../components/LatestNews/LatestNews';
import SEO from '../components/SEO/SEO';
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';
import Wrapper from '../components/Wrapper/Wrapper';

const generateSlug = (name) => name.replace(/\s+/g, '-').toLowerCase();

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 0.7fr 2.3fr; /* Avatar e informazioni */
  gap: 2em;
  align-items: center;

  @media (max-width: 768px) {
    gap: 1em;
    grid-template-columns: 1fr; /* Una colonna su dispositivi mobili */
    margin-bottom: 1.5em;
  }
`;

const TextAlignMobile = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Avatar = styled.img`
  border-radius: 50%;
  width: 200px;
  height: 200px;
  margin: 0 auto; /* Centra l'immagine su dispositivi mobili */
`;

const MemberInfo = styled.div`
  h2 {
    font-size: 2rem;
    margin: 0 0 0.5em;
  }

  p {
    font-size: 1rem;
    color: #555;
    margin: 0;
  }
`;

const TeamMemberDetails = () => {
    const { authorSlug } = useParams(); // Ottieni lo slug dell'autore
    const [currentPage, setCurrentPage] = useState(1);
    const [latestNewsArticles, setLatestNewsArticles] = useState([]);

    // Usa la query React Query per il team
    const { data: response } = useTeam();
    const team = response?.data || [];
    const member = team?.find((m) => generateSlug(m.name) === authorSlug);

    // Usa la query React Query per gli articoli dell'autore
    const { data: articlesResponse } = useAuthorArticles({
        author: authorSlug,
        page: currentPage,
        perPage: 10,
    });
    const articles = articlesResponse?.data || [];
    const meta = articlesResponse?.meta;

    useEffect(() => {
        const newArticles = articles?.filter(
            (article) =>
                !latestNewsArticles.some((a) => a.id === article.id)
        );
        setLatestNewsArticles((prev) => [...prev, ...newArticles]);
    }, [articles, currentPage]);

    const handleLoadMore = () => {
        if (meta && currentPage < meta.total_pages) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    return (
        <>
        {member && articles && (
            <div>
                <SEO
                    title={`${member?.name} di Rossomotori.it`}
                    description={`Membro del team di Rossomotori.it`}
                    url={`https://rossomotori.it/team/${authorSlug}`}
                />
                <Breadcrumb />
                <div style={{ marginTop: '2em' }}>
                    <GridContainer>
                        <Avatar src={member?.avatar} alt={`${member?.name}'s avatar`} />
                        <MemberInfo>
                            <TextAlignMobile>
                                <h2>{member?.name}</h2>
                            </TextAlignMobile>
                            <p>{member?.bio || 'Bio non specificata'}</p>
                        </MemberInfo>
                    </GridContainer>

                    {latestNewsArticles?.length > 0 ? (
                        <LatestNews
                            articles={latestNewsArticles}
                            title={`Gli Articoli di ${member?.name}`}
                            onLoadMore={handleLoadMore}
                            meta={meta}
                            disableInitialBlock={true}
                        />
                    ) : (
                        <div style={{ marginTop: '5em' }}>
                            <p>Non ci sono articoli disponibili al momento.</p>
                        </div>
                    )}
                </div>
            </div>
            )}
        </>
    );
};

export default TeamMemberDetails;
